import React, {useEffect} from 'react'
import {observer} from 'mobx-react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import PropTypes from 'prop-types';
import Utility from "../../../../../src/Utility";
import ConditionalComponent from "../../../../../src/Components/Shared/ConditionalComponent";
import Tooltip from "@mui/material/Tooltip";
import {Dialog} from "@mui/material";
import '../../../Modals/modal.scss'
import {useStores} from "../../../../Hooks";
import {getNodeMedia} from "../../../../serverClientShared/sharedUtils";

const PopupMediaSelect = observer(props => {
    const {generalStore, procedureStore} = useStores();

    const {currentNode, inSidebar, currentProcedure} = props;
    const { warningPopupPreviewedFile} = procedureStore;
    const mediaFiles = getNodeMedia(currentNode, "NodeMediaFilesRefs", currentProcedure).FileRefs;
    const settings = {
        dots: mediaFiles.length < 13,
        dotsClass: "slick-dots",
        infinite: false,
        speed: 250,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        focusOnSelect: true,
        initialSlide: 0,
    };


    useEffect(() => {
        generalStore.sliderRefreshProcedureFlag = true;
        setTimeout(() => {
            generalStore.sliderRefreshProcedureFlag = false;
        }, 0)
        // eslint-disable-next-line
    }, []);

    function setPopup(fileIndex) {
        procedureStore.warningPopupPreviewedFile = mediaFiles[fileIndex];
        procedureStore.updateMediaInSession(null, procedureStore.warningPopupPreviewedFile);
    }

    function populateThumbnails(files) {
        return (
            files.map((file, index) => (
                <div className='media-thumbnail out-of-sidebar'
                     onClick={() => setPopup(index)}
                     key={index}>
                    {Utility.renderFileThumbnail(file)}
                    <ConditionalComponent if={!inSidebar}>
                        <Tooltip
                            className="thumbnail-filename-container"
                            title={file.FileName}
                            placement="top"
                            enterDelay={800}
                        >
                            <div className="thumbnail-filename-background"/>
                        </Tooltip>
                    </ConditionalComponent>
                </div>
            ))
        )
    }

    return (
        <div className="media-select-container">
            <div className='thumbnail-carousel'>
                <Slider {...settings}>
                    {populateThumbnails(mediaFiles)}
                </Slider>
            </div>

            <Dialog
                open={!!warningPopupPreviewedFile && !generalStore.isInFullscreen}
                onClose={() => procedureStore.warningPopupPreviewedFile = null}
                maxWidth='md'
                className='popup-media-preview'
            >
                {Utility.renderFilePreview(warningPopupPreviewedFile, generalStore.translate)}
            </Dialog>
        </div>
    )
});

PopupMediaSelect.propTypes = {
    currentNode: PropTypes.object.isRequired
}

export default PopupMediaSelect
